import {
  EXCELLENT_INDICATOR_DESCRIPTION,
  EXCELLENT_INDICATOR_TITLE,
  GOOD_INDICATOR_DESCRIPTION,
  GOOD_INDICATOR_TITLE,
  NEEDS_IMPROVEMENT_INDICATOR_DESCRIPTION,
  NEEDS_IMPROVEMENT_TITLE,
  POOR_INDICATOR_DESCRIPTION,
  POOR_INDICATOR_TITLE,
  SATISFACTORY_INDICATOR_DESCRIPTION,
  SATISFACTORY_INDICATOR_TITLE,
} from './constants';

export const getDescription = (percentage: number) => {
  let description;

  switch (true) {
    case percentage > 90 && percentage <= 100:
      description = {
        title: EXCELLENT_INDICATOR_TITLE,
        detail: EXCELLENT_INDICATOR_DESCRIPTION,
      };
      break;
    case percentage > 80 && percentage <= 90:
      description = {
        title: GOOD_INDICATOR_TITLE,
        detail: GOOD_INDICATOR_DESCRIPTION,
      };
      break;
    case percentage > 60 && percentage <= 80:
      description = {
        title: SATISFACTORY_INDICATOR_TITLE,
        detail: SATISFACTORY_INDICATOR_DESCRIPTION,
      };
      break;
    case percentage > 40 && percentage <= 60:
      description = {
        title: NEEDS_IMPROVEMENT_TITLE,
        detail: NEEDS_IMPROVEMENT_INDICATOR_DESCRIPTION,
      };
      break;
    case percentage <= 40:
      description = {
        title: POOR_INDICATOR_TITLE,
        detail: POOR_INDICATOR_DESCRIPTION,
      };
      break;
    default:
      description = {
        title: 'Error: No achievement percentage',
        detail: '',
      };
  }

  return description;
};

export const roundTo2Decimals = (value: number) => {
  return `${(Math.round(value * 100) / 100).toFixed(2)}`;
};
